import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { XpressUserService } from 'app/services';

@Component({
    selector: 'banned-user',
    templateUrl: './banned-user.component.html',
    styleUrls: ['./banned-user.component.scss'],
    providers: [MessageService]
})
export class BannedUserComponent implements OnInit {
    @Input() public userId: number | null = null;
    @Input() public userName: string | null = null;

    public displayModalBanned: boolean = false;
    @Input()
    set _displayModalBanned(value: boolean) {
        this.displayModalBanned = value;
        if (value) {
            this.resetForm();
        }
    }

    @Output() changedDisplayModalBannedEmit = new EventEmitter<any>();
    @Output() banSuccessEmit = new EventEmitter<void>();
    @Output() liftBanSuccessEmit = new EventEmitter<void>();

    @Input() _isLiftBanAction!: boolean;

    reasonOptions = [
        { label: 'Repeated violation while suspended', value: 'Repeated violation while suspended' },
        { label: 'Fraud / Chargeback', value: 'Fraud / Chargeback' },
        { label: 'Abuse / Harassment', value: 'Abuse / Harassment' },
        { label: 'Policy Violation', value: 'Policy Violation' },
        { label: 'Other', value: 'Other' }
    ];

    selectedReason: string | null = null;
    bannedNotes: string = '';

    liftBanReasonOptions = [
        { label: 'Appeal approved', value: 'Appeal approved' },
        { label: 'Risk cleared', value: 'Risk cleared' },
        { label: 'Ops override', value: 'Ops override' },
        { label: 'Other', value: 'Other' }
    ];

    selectedLiftReason: string | null = null;
    liftBanNotes: string = '';

    public response: any = {
        displayModalBanned: false
    };

    constructor(
        private messageService: MessageService,
        private xpressUserService: XpressUserService
    ) { }

    ngOnInit(): void { }

    isFormValid(): boolean {
        return !!this.selectedReason;
    }

    isLiftFormValid(): boolean {
        return !!this.selectedLiftReason;
    }

    resetForm(): void {
        this.selectedReason = null;
        this.bannedNotes = '';
        this.selectedLiftReason = null;
        this.liftBanNotes = '';
    }

    liftBanUser() {
        if (!this.isLiftFormValid()) { return; }

        const reason = this.liftBanNotes?.trim()
            ? `${this.selectedLiftReason} - ${this.liftBanNotes.trim()}`
            : this.selectedLiftReason;

        const dto = {
            UserId: this.userId,
            Reason: reason
        };
        this.xpressUserService.liftBanUser(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.cancel();
                this.liftBanSuccessEmit.emit();
            });
    }

    public bannedUser() {
        if (!this.isFormValid()) { return; }

        const dto = {
            UserId: this.userId,
            BannedReason: this.selectedReason,
            BannedNotes: this.bannedNotes?.trim() || null
        };

        this.xpressUserService.bannedUser(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.cancel();
                this.banSuccessEmit.emit();
            })
            .catch(err => {
                throw err;
            });
    }

    cancel() {
        this.displayModalBanned = false;
        this.response.displayModalBanned = false;
        this.changedDisplayModalBannedEmit.emit(this.response);
    }
}
